import '@angular/localize/init';
export * from './lib/feature-tax-donation-list.module';

export * from './lib/tax-donation-list/feature-tax-donation-list.component';
